import { observable } from "mobx";
import http from 'libs/http';

class Store {
  @observable records = [];
  @observable types = [];
  @observable record = {};
  @observable isFetching = false;
  @observable formVisible = false;
  @observable class_info = [];

  @observable f_class;

  fetchRecords = () => {
    this.isFetching = true;
    http.get('/api/homework/record/')
      .then((res) => {
        this.records = res;
      })
      .finally(() => this.isFetching = false)
  };

  showForm = (info = {}) => {
    this.formVisible = true;
    this.record = info
  }
}

export default new Store()
